import { z } from 'zod'

import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetAlertCommentPathParameterSchema = z.object({
  alertId: numberOrStringToNumberSchema,
})

export const GetAlertCommentResponseSchema = z.array(
  z.object({
    id: numberOrStringToNumberSchema,
    alertId: numberOrStringToNumberSchema,
    text: z.string().nullable(),
    createdAt: z
      .union([z.string(), z.date()])
      .transform((date) => new Date(date))
      .nullable(),
    updatedAt: z
      .union([z.string(), z.date()])
      .transform((date) => new Date(date))
      .nullable(),
    firstname: z.string().nullable(),
    lastname: z.string().nullable(),
  }),
)

export type GetAlertCommentPathParameter = z.infer<typeof GetAlertCommentPathParameterSchema>
export type GetAlertCommentResponse = z.infer<typeof GetAlertCommentResponseSchema>
